import type { SVGProps } from "react";
const SvgBehaviors = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 27 26" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.296 1.5h1.63v2.852c1.228.212 2.35.69 3.367 1.431l1.736-1.75 2.314 2.334-1.788 1.802a8.893 8.893 0 0 1 1.315 3.394h2.63v3.234h-2.735a8.14 8.14 0 0 1-1.42 3.181l2.05 2.015-2.314 2.333-2.05-2.068a8.754 8.754 0 0 1-3.104 1.273V24.5h-1.63m.735-15.8c1.123 0 2.105.406 2.946 1.22.807.847 1.21 1.855 1.21 3.021 0 1.167-.403 2.174-1.21 3.022-.841.813-1.823 1.22-2.946 1.22"
    />
    <path
      className="icon-color-4"
      fill="#fff"
      d="m9.5 2 3.5-.5h.5v23H11L9 24l-1-1-.5-.5L7 22H5.5L4 20.5 3 19v-1.5l.5-1-1-.5-1-2v-2.5l.5-3 1.5-1 1-2 1.5-1h1.5L8 3l1.5-1Z"
    />
    <path className="icon-color-4" fill="#fff" d="M5.5 10.5c2.026 1 1.257 3 0 4v-4Z" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 21c0-1 1.5-1.535 2.866-1.535m0 0v5.129C12.069 24.558 8.5 25 7.526 22m5.84-2.535V13.5m0-7c-1.614.028-2.484 0-3.156-1.173M13.366 6.5v-5c-4.366 0-5.84 1.009-5.84 3m5.84 2v7M7.526 22C6 23 1.63 19.86 3.5 16.5c-1.648-.707-2.07-1.38-2-4.067C1.5 10 2 7.5 3.5 7.5c0-2 1.423-3 4.026-3m0 17.5c0-1.352 0-4 2.684-5M7.526 4.5c-.026 2.009 0 3.5 1.974 4m-4 6c1.257-1 2.026-3 0-4m7.866 3c-.866-1-1.866-1.5-3.314 0-.9.933-2.558.112-3.327-.955M6.5 17c0 1 .567 1.616 1.5 2"
    />
  </svg>
);
export default SvgBehaviors;
